'use client';

import { c as _c } from "react/compiler-runtime";
import { defaultPreLiquidationParamsRegistry, type MarketId } from '@morpho-org/blue-sdk';
import { toBigInt, ZERO } from '@morpho-org/dapp-core';
import { InfoTooltip } from '@morpho-org/ui-v6/client';
import { Card, CardText, Skeleton } from '@morpho-org/ui-v6/server';
import { formatters } from '@morpho-org/ui-v6/utils';
import { Icon, Separator } from '@repo/ui';
import { ShieldCheckGradient } from '@repo/ui/icons';
import { AUTO_DELEVERAGE_LIQ_LTV_TOOLTIP_CONTENT } from '../utils/constants';
import AutoDeleverageMarketInfos from './AutoDeleverageMarketInfos';
import { useAutoDeleverageDialogData } from './useAutoDeleverageDialogData';
interface AutoDeleverageRecapProps {
  toEnable: boolean;
  marketId: MarketId;
}
const AutoDeleverageRecap = t0 => {
  const $ = _c(28);
  const {
    toEnable,
    marketId
  } = t0;
  const {
    data,
    error: marketQueryError,
    isPending: isMarketLoading
  } = useAutoDeleverageDialogData(marketId);
  const lltv = data?.lltv;
  const loanAsset = data?.loanToken;
  const collateralAsset = data?.collateralToken;
  let t1;
  if ($[0] !== lltv) {
    t1 = formatters.percent.digits(2).default("-").trailingZero(false).unit("%").of(toBigInt(lltv), 18);
    $[0] = lltv;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const formattedLltv = t1;
  let t2;
  if ($[2] !== lltv) {
    t2 = formatters.percent.digits(2).default("-").trailingZero(false).unit("%").of(defaultPreLiquidationParamsRegistry.get(toBigInt(lltv) ?? ZERO)?.preLltv, 18);
    $[2] = lltv;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const formattedPreLltv = t2;
  if (isMarketLoading) {
    let t3;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = <Skeleton className="h-[170px] rounded-[20px]" />;
      $[4] = t3;
    } else {
      t3 = $[4];
    }
    return t3;
  }
  if (marketQueryError || !loanAsset || !collateralAsset) {
    let t3;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = <CardText text="An error occurred while loading the market data." className="bg-muted rounded-xl shadow-none" height="170px" />;
      $[5] = t3;
    } else {
      t3 = $[5];
    }
    return t3;
  }
  let t3;
  if ($[6] !== collateralAsset || $[7] !== formattedLltv || $[8] !== loanAsset || $[9] !== marketId) {
    t3 = <AutoDeleverageMarketInfos collateralAsset={collateralAsset} loanAsset={loanAsset} formattedLltv={formattedLltv} marketId={marketId} />;
    $[6] = collateralAsset;
    $[7] = formattedLltv;
    $[8] = loanAsset;
    $[9] = marketId;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  let t4;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Separator />;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      lineHeight: "normal"
    };
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  const t6 = toEnable ? "Enable" : "Remove";
  let t7;
  if ($[13] !== t6) {
    t7 = <span className="text-secondary-foreground text-xs" style={t5}>{t6} Auto Deleverage Liq. LTV</span>;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <InfoTooltip tooltipContent={AUTO_DELEVERAGE_LIQ_LTV_TOOLTIP_CONTENT} />;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== t7) {
    t9 = <div className="gap-2xs flex items-center">{t7}{t8}</div>;
    $[16] = t7;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <Icon icon={<ShieldCheckGradient />} />;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = {
      lineHeight: "normal"
    };
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  let t12;
  if ($[20] !== formattedPreLltv) {
    t12 = <div className="flex items-center gap-[2px]">{t10}<span className="text-title-xs" style={t11}>{formattedPreLltv}</span></div>;
    $[20] = formattedPreLltv;
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  let t13;
  if ($[22] !== t12 || $[23] !== t9) {
    t13 = <div className="gap-sm flex w-[100%] flex-col">{t4}{t9}{t12}</div>;
    $[22] = t12;
    $[23] = t9;
    $[24] = t13;
  } else {
    t13 = $[24];
  }
  let t14;
  if ($[25] !== t13 || $[26] !== t3) {
    t14 = <Card padding="s" className="bg-muted rounded-xl shadow-none"><div className="gap-lg flex w-[100%] flex-col">{t3}{t13}</div></Card>;
    $[25] = t13;
    $[26] = t3;
    $[27] = t14;
  } else {
    t14 = $[27];
  }
  return t14;
};
export default AutoDeleverageRecap;